export function hostedTrialSlider() {

    const settings = {
      arrows: false,
        centerMode: true,
        centerPadding: 0,
        variableWidth: true,
        infinite: false,
        slidesToShow: 1,
        breakpoints: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4
                }
            },

            {
                breakpoint: 767,
                settings: {

                    slidesToShow: 1
                }
            },
        ]
    };

    function initSlider() {
        if(window.innerWidth < 1200){
            $(".trial-slider:not(.slick-initialized)").slick(settings);
        } else {
            $(".trial-slider.slick-initialized").slick("unslick");
        }
    }

    $(window).on("load resize", function () {
        initSlider();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hosted-trial-slider.js